//@ts-nocheck

declare global {
  interface Window {
    dataLayer: any;
  }
}

export const sliderCampaigns = () => {
  if (typeof Swiper !== 'undefined') {
    // thumbsSlider
    var swiper = new Swiper(".campaignsThumbsSlider", {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        600: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });

    const thumbsValidate = document.querySelector(".campaignsThumbsSlider");
    let thumbs = {};
    if (thumbsValidate) {
      thumbs = {
        thumbs: {
          swiper: swiper,
        },
      };
    } else {
      thumbs = {};
    }

    // slider
    const config = {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      ...thumbs,
    };
    var swiper2 = new Swiper(".campaignsSwiper", config);

    let btnBannerSlider = document.querySelectorAll(
      ".campaignsSwiper .bannerSlider--link"
    ) as any;
    if (btnBannerSlider) {
      let arrayBtns = [...btnBannerSlider];
      arrayBtns.forEach((element) => {
        element.addEventListener("click", (e: any) => {
          let wrapper = e.target.closest(".bannerSlider--content");
          let nameProduct = wrapper.querySelector(".bannerSlider--title");
          window.dataLayer.push({
            event: "trackEvent",
            eventCategory: "Presidente Largo Plazo 2022", // Categoría del evento (String). Requerido.
            eventAction: "Campañas- Banner Home", // Acción o subcategoría del evento (String). Requerido.
            eventLabel: nameProduct.textContent, // Etiqueta de descripción del evento (String). Requerido.
          });
        });
      });
    }
  }
};

export const sliderInstagramCampaigns = () => {
  if (document.querySelector(".campaignsInstagram")) {
    // thumbsSlider
    var thumbsSlider = new Swiper(".campaignsInstagramThumbsSlider", {
      spaceBetween: 10,
      slidesPerView: 3,
      slidesPerGroup: 3,
      freeMode: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
        },
      },
    });
    // thumbsSlider
    let swiperInstagram = new Swiper(".campaignsInstagram", {
      spaceBetween: 10,
      slidesPerView: 1,
      slidesPerGroup: 1,
      freeMode: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".campaigns-instagram .swiper-button-next",
        prevEl: ".campaigns-instagram .swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 40,
        },
      },
      thumbs: {
        swiper: thumbsSlider,
      },
    });
  }
};
